/*Import Estilo*/
import './index.scss';
import '../../../css/global.css';
import '../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';


/*Import Componentes*/
import Cabecalho from '../../../components/Cabecalho';
import Rodape from '../../../components/Rodape';
import CookieAceite from '../../../components/CookieAceite';

/*Import Contexto*/
import { useAuth } from '../../../context/AuthContext';
import { useCart } from '../../../context/CartContext';

/*Import Requisição API*/
import api from '../../../api';
import { formatadorNumeroCelular, validadorNumeroCelular } from '../../../utils/Validadores/index.js';

export default function Contato() {


    const [nome, setNome] = useState('');
    const [sobrenome, setSobrenome] = useState('');
    const [email, setEmail] = useState('');
    const [telefone, setTelefone] = useState('');
    const [assunto, setAssunto] = useState('');
    const [mensagem, setMensagem] = useState('');

    const [loading, setLoading] = useState(false);

    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const recaptchaRef = useRef(null);

    const navigate = useNavigate();

    const { setUserId, setNivelAcesso } = useAuth();

    const [celularValido, setCelularValido] = useState(null);

    const [texto, setTexto] = useState('');
    const [modalAberto, setModalAberto] = useState(false);
    const CaixaDeDialogoConfirmacao = useRef(null);
    const CaixaDeDialogoSucesso = useRef(null);
    useEffect(() => {
        CaixaDeDialogoConfirmacao.current = document.getElementById("CaixaDeDialogoConfirmacao");
    }, []);

    const abrirModalConfirmacao = (e) => {
        if (CaixaDeDialogoConfirmacao.current) {
            CaixaDeDialogoConfirmacao.current.showModal();
        }
    };

    const fecharModalConfirmacao = () => {
        if (CaixaDeDialogoConfirmacao.current) {
            CaixaDeDialogoConfirmacao.current.close();
            setRecaptchaToken(null);
        }
    };

    const CaixaDeDialogo = useRef(null);
    useEffect(() => {
        CaixaDeDialogo.current = document.getElementById("CaixaDeDialogo");
    }, []);

    const abrirModal = (e) => {
        if (CaixaDeDialogo.current) {
            CaixaDeDialogo.current.showModal();
        }
    };

    const fecharModal = () => {
        if (CaixaDeDialogo.current) {
            CaixaDeDialogo.current.close();
            setRecaptchaToken(null);
        }
    };

    const onRecaptchaChange = (token) => {
        console.log('recaptcha token recebido (change):', token);
        setRecaptchaToken(token);
    };

    useEffect(() => {
        CaixaDeDialogoSucesso.current = document.getElementById("CaixaDeDialogoSucesso");
    }, []);

    const mostrarModalSucesso = () => {
        if (CaixaDeDialogoSucesso.current) {
            CaixaDeDialogoSucesso.current.showModal();
        }
    };

    const handleCelularChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        setTelefone(value);

        if (value.length === 0) {
            setCelularValido(null);
        } else {
            setCelularValido(validadorNumeroCelular(value));
        }
    };

    const handleBlur = () => {
        const formattedValue = formatadorNumeroCelular(telefone);
        setTelefone(formattedValue);
    };

    const handleSubmit = async (e) => {
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        setLoading(true);
        fecharModalConfirmacao();

        const formDataToSend = {
            firstName: nome,
            lastName: sobrenome,
            email,
            subject: assunto,
            phone: telefone,
            message: mensagem,
            recaptchaToken // incluímos o token para validação no backend
        };

        try {
            console.log('Enviando para /caseSalesforce', formDataToSend);
            const response = await api.post('/caseSalesforce', formDataToSend);

            // limpa campos
            setNome(''); setSobrenome(''); setEmail(''); setTelefone(''); setAssunto(''); setMensagem('');

            // Fecha modal de confirmação
            fecharModalConfirmacao();

            console.log('Resposta backend:', response.data);

            if (response.data.success) {
                setTexto('Obrigado por falar conosco! Em breve entraremos em contato!');
                mostrarModalSucesso();
                setTimeout(() => { navigate('/'); }, 5000);
            } else {
                alert(response.data.message || 'Erro ao enviar o caso.');
            }
        } catch (error) {
            console.error('Erro ao enviar o caso:', error);
            if (error.response) {
                console.error('error.response.data:', error.response.data);
                alert(`Erro do servidor: ${error.response.status} - ${JSON.stringify(error.response.data)}`);
            } else if (error.request) {
                console.error('No response (request):', error.request);
                alert('Sem resposta do servidor. Verifique a conexão.');
            } else {
                console.error('Error message:', error.message);
                alert('Erro: ' + error.message);
            }
        } finally {
            setLoading(false);
            try { recaptchaRef.current?.reset(); } catch (e) { }
            setRecaptchaToken(null);
        }
    };

    const handleConfirmarEnviar = async (e) => {
        e.preventDefault();
        if (!nome || !sobrenome || !email || !assunto || !telefone || !mensagem) {
            setTexto('Preencha todos os campos para enviar o formulario!');
            abrirModal();
            return;
        }
        if (!recaptchaToken) {
            abrirModalConfirmacao();
            return;
        }
        await handleSubmit();
    };

    return (
        <section className='container-Principal-Contato'>

            <Cabecalho />

            <CookieAceite />
            <dialog id="CaixaDeDialogoConfirmacao" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <h3>Confirme que você não é um robô</h3>
                    <p>Marque a caixa abaixo e depois clique em "Confirmar e Enviar".</p>

                    <div style={{ margin: '16px 0' }}>
                        <ReCAPTCHA
                            sitekey={'6LfQ7_crAAAAAMdMzALHq9aIV07Zgr41Wif-eswp'}
                            onChange={onRecaptchaChange}
                            ref={recaptchaRef}
                            theme="light"
                        />
                    </div>

                    <div className='dialog-button'>
                        <button className='cancelar' onClick={fecharModalConfirmacao} disabled={loading}>Cancelar</button>
                        <button
                            onClick={handleConfirmarEnviar}
                            disabled={!recaptchaToken || loading}
                            className='confirmar'
                        >
                            {loading ? 'Enviando...' : 'Confirmar e Enviar'}
                        </button>
                    </div>
                </div>
            </dialog>

            <dialog id="CaixaDeDialogoSucesso">
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><g fill="none" stroke="#4AC204" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path stroke-dasharray="64" stroke-dashoffset="64" d="M3 12c0 -4.97 4.03 -9 9 -9c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9Z"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="64;0" /></path><path stroke-dasharray="14" stroke-dashoffset="14" d="M8 12l3 3l5 -5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.6s" dur="0.2s" values="14;0" /></path></g></svg>
                        <p>{texto}</p>
                    </div>
                </div>
            </dialog>

            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>{texto}</p>
                        <button id="botao" onClick={fecharModal}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <main className="main-contato">
                <section className="conteudoMain">
                    <ul class="circulos">
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                    {loading ? (
                        <div className="loading">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#fff" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity="0.25" /><path fill="#fff" d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"><animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" /></path></svg>
                            <h2>Carregando...</h2>
                        </div>
                    ) : (
                        <>
                            <div className='container-interno-forms'>
                                <h2>Entre em contato conosco pelos nosso canais</h2>
                                <div className='container-btn'>
                                    <Link to='/contato/negocio' className='bnt-Parcerias'><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.7991 5.96575C17.8408 4.92409 17.3658 3.70742 16.7991 3.11575L14.2991 0.615753C13.2491 -0.425914 12.0408 0.0490864 11.4491 0.615753L10.0324 2.04075H7.87409C6.29075 2.04075 5.37409 2.87409 4.90742 3.83242L1.20742 7.53242V10.8658L0.615753 11.4491C-0.425914 12.4991 0.0490864 13.7074 0.615753 14.2991L3.11575 16.7991C3.56575 17.2491 4.04909 17.4158 4.50742 17.4158C5.09909 17.4158 5.64075 17.1241 5.96575 16.7991L8.21575 14.5408H11.2074C12.6241 14.5408 13.3408 13.6574 13.5991 12.7908C14.5408 12.5408 15.0574 11.8241 15.2658 11.1241C16.5574 10.7908 17.0408 9.56575 17.0408 8.70742V6.20742H16.5491L16.7991 5.96575ZM15.3741 8.70742C15.3741 9.08242 15.2158 9.54075 14.5408 9.54075H13.7074V10.3741C13.7074 10.7491 13.5491 11.2074 12.8741 11.2074H12.0408V12.0408C12.0408 12.4158 11.8824 12.8741 11.2074 12.8741H7.53242L4.79909 15.6074C4.54075 15.8491 4.39075 15.7074 4.29909 15.6158L1.80742 13.1324C1.56575 12.8741 1.70742 12.7241 1.79909 12.6324L2.87409 11.5491V8.21575L4.54075 6.54909V7.87409C4.54075 8.88242 5.20742 10.3741 7.04075 10.3741C8.87409 10.3741 9.54075 8.88242 9.54075 7.87409H15.3741V8.70742ZM15.6158 4.78242L14.1991 6.20742H7.87409V7.87409C7.87409 8.24909 7.71575 8.70742 7.04075 8.70742C6.36575 8.70742 6.20742 8.24909 6.20742 7.87409V5.37409C6.20742 4.99075 6.34909 3.70742 7.87409 3.70742H10.7158L12.6158 1.80742C12.8741 1.56575 13.0241 1.70742 13.1158 1.79909L15.6074 4.28242C15.8491 4.54075 15.7074 4.69075 15.6158 4.78242Z"/></svg> Formulario para Parcerias</Link>
                                    <Link to='/contato/problema' className='bnt-Problemas'><svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.86083 1.15687C8.68458 -0.385625 10.8946 -0.385625 11.7183 1.15687L19.3208 15.3794C19.499 15.7126 19.5878 16.0864 19.5785 16.4641C19.5693 16.8419 19.4623 17.2109 19.2681 17.535C19.0738 17.8592 18.7989 18.1275 18.4702 18.3138C18.1414 18.5001 17.77 18.5981 17.3921 18.5981H2.18708C1.80919 18.5981 1.43777 18.5001 1.109 18.3138C0.780227 18.1275 0.50533 17.8592 0.311092 17.535C0.116854 17.2109 0.0099007 16.8419 0.00065497 16.4641C-0.00859076 16.0864 0.0801861 15.7126 0.258335 15.3794L7.86083 1.15687ZM10.0646 2.04062C10.0378 1.99102 9.99811 1.94957 9.9497 1.92069C9.90128 1.8918 9.84596 1.87655 9.78958 1.87655C9.73321 1.87655 9.67789 1.8918 9.62947 1.92069C9.58106 1.94957 9.54136 1.99102 9.51459 2.04062L1.91208 16.2631C1.88661 16.3107 1.8739 16.3641 1.87517 16.418C1.87645 16.472 1.89167 16.5247 1.91936 16.571C1.94705 16.6173 1.98626 16.6557 2.03318 16.6823C2.0801 16.709 2.13312 16.723 2.18708 16.7231H17.3921C17.446 16.723 17.4991 16.709 17.546 16.6823C17.5929 16.6557 17.6321 16.6173 17.6598 16.571C17.6875 16.5247 17.7027 16.472 17.704 16.418C17.7053 16.3641 17.6926 16.3107 17.6671 16.2631L10.0646 2.04062ZM10.7271 7.03562V10.1606C10.7271 10.4093 10.6283 10.6477 10.4525 10.8235C10.2767 10.9994 10.0382 11.0981 9.78958 11.0981C9.54094 11.0981 9.30249 10.9994 9.12667 10.8235C8.95086 10.6477 8.85208 10.4093 8.85208 10.1606V7.03562C8.85208 6.78698 8.95086 6.54853 9.12667 6.37271C9.30249 6.1969 9.54094 6.09812 9.78958 6.09812C10.0382 6.09812 10.2767 6.1969 10.4525 6.37271C10.6283 6.54853 10.7271 6.78698 10.7271 7.03562ZM11.0396 13.5981C11.0396 13.9296 10.9079 14.2476 10.6735 14.482C10.439 14.7164 10.1211 14.8481 9.78958 14.8481C9.45806 14.8481 9.14012 14.7164 8.9057 14.482C8.67128 14.2476 8.53958 13.9296 8.53958 13.5981C8.53958 13.2666 8.67128 12.9487 8.9057 12.7142C9.14012 12.4798 9.45806 12.3481 9.78958 12.3481C10.1211 12.3481 10.439 12.4798 10.6735 12.7142C10.9079 12.9487 11.0396 13.2666 11.0396 13.5981Z"/></svg> Formulario para Problemas</Link>
                                    <button className='bnt-WhatsApp' href='#' onClick={() => window.open('https://wa.me/5511997636154', '_blank')}><svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.36132 39.1187L1.1339 39.9537L1.97086 39.7337L11.6241 37.1963C14.3712 38.6561 17.4451 39.4314 20.575 39.4314C31.0886 39.4314 39.6563 30.8637 39.6563 20.3501C39.6563 15.2495 37.6729 10.4538 34.0732 6.85366C32.3074 5.07087 30.2045 3.65728 27.887 2.69524C25.5694 1.73315 23.0835 1.2419 20.5742 1.2501C10.0609 1.25055 1.49375 9.81799 1.49375 20.3314C1.49375 23.6303 2.34289 26.837 3.93223 29.6798L1.36132 39.1187ZM12.0104 32.804L6.99793 34.1214L8.3261 29.2568L8.38487 29.0415L8.2639 28.854L7.89074 28.2756C6.39955 25.894 5.60793 23.1411 5.60625 20.3311C5.60641 12.0948 12.32 5.38135 20.5562 5.38135C24.5483 5.38135 28.3018 6.9409 31.1141 9.77127L31.1161 9.77327C32.5084 11.1588 33.6118 12.8071 34.3622 14.6224C35.1126 16.4377 35.4951 18.3839 35.4875 20.3482L35.4875 20.3523C35.5238 28.5857 28.8126 35.2813 20.575 35.2813C17.8907 35.2813 15.2602 34.556 12.9556 33.1954C12.9552 33.1951 12.9547 33.1948 12.9543 33.1946L12.3947 32.8589L12.2141 32.7505L12.0104 32.804ZM26.0706 22.2498L26.0582 22.2448L26.0455 22.2404L26.0421 22.2392C25.8435 22.1701 25.5561 22.0701 25.2588 22.1032C24.9062 22.1423 24.6371 22.3467 24.4232 22.6486L24.4232 22.6485L24.4178 22.6564C24.1183 23.0968 23.2561 24.1258 22.9925 24.4271L22.9875 24.4327L22.9828 24.4385C22.941 24.4892 22.9129 24.511 22.899 24.5198C22.8889 24.5261 22.8853 24.5265 22.8827 24.5268L22.8823 24.5269C22.8675 24.5286 22.788 24.5298 22.5869 24.4252L22.5798 24.4216L22.5726 24.4181C22.4969 24.3817 22.4005 24.3402 22.2857 24.2907C21.6371 24.011 20.3988 23.4772 18.9582 22.1898L18.9578 22.1895C17.6373 21.0117 16.7531 19.5582 16.4705 19.0875C16.4311 19.0158 16.4225 18.9754 16.4206 18.9604C16.4191 18.949 16.4203 18.9469 16.4213 18.9442C16.4239 18.9369 16.433 18.9167 16.4631 18.8789C16.4946 18.8393 16.5358 18.7964 16.5973 18.7349C16.7548 18.5774 16.9501 18.3414 17.1207 18.1354C17.192 18.0492 17.2591 17.9683 17.3171 17.9005C17.5648 17.6115 17.6862 17.3669 17.8151 17.1071C17.8278 17.0816 17.8405 17.0559 17.8535 17.03L17.8536 17.03L17.8587 17.0192C18.1004 16.5056 17.9633 16.0711 17.816 15.7765C17.7155 15.5756 16.7886 13.3159 16.408 12.3644L16.408 12.3644L16.4053 12.3578C16.1945 11.8518 15.9366 11.5275 15.6002 11.3658C15.3341 11.238 15.0217 11.2435 14.944 11.2449C14.9351 11.245 14.9293 11.2451 14.927 11.245L14.9104 11.2439H14.8938H13.9937C13.5586 11.2439 12.929 11.3988 12.3883 11.9866L12.3882 11.9865L12.3809 11.9948C12.3502 12.0297 12.3142 12.0691 12.274 12.1132C11.7803 12.6541 10.6438 13.8995 10.6438 16.2064C10.6438 17.4628 11.099 18.6697 11.5605 19.5781C12.0196 20.4819 12.507 21.1324 12.6328 21.3001C12.642 21.3133 12.6555 21.3331 12.6731 21.3588C13.116 22.0078 16.1792 26.4962 20.769 28.4772C21.897 28.9742 22.7781 29.2617 23.4628 29.4709C24.6699 29.8588 25.7667 29.7937 26.6066 29.6766L26.6097 29.6761C27.1544 29.5967 27.9115 29.2778 28.5704 28.8543C29.2157 28.4394 29.8945 27.843 30.1401 27.1356C30.3509 26.5525 30.4586 26.0091 30.4951 25.5739C30.5134 25.3565 30.5145 25.158 30.4988 24.9898C30.4854 24.8458 30.454 24.6465 30.3531 24.4879C30.2169 24.2739 30.0202 24.149 29.8521 24.0595C29.7539 24.0073 29.6259 23.9481 29.4938 23.887C29.4177 23.8518 29.3402 23.816 29.2664 23.7806C29.1606 23.7298 28.9497 23.6271 28.6838 23.4975C27.8272 23.0801 26.3992 22.3843 26.0706 22.2498Z" /></svg>Via WhatsApp</button>
                                    <Link className='bnt-Email' onClick={() => window.open('mailto:fracarostore@gmail.com')}><svg width="39" height="31" viewBox="0 0 39 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.5795 17.5022L34.35 8.27064V26.6H4.65V8.27064L19.4205 17.5022L19.5 17.5519L19.5795 17.5022ZM38.4 4.25C38.4 2.10466 36.6453 0.35 34.5 0.35H4.5C2.35466 0.35 0.6 2.10466 0.6 4.25V26.75C0.6 28.8953 2.35466 30.65 4.5 30.65H34.5C36.6453 30.65 38.4 28.8953 38.4 26.75V4.25ZM19.5 13.4481L5.02302 4.4H33.977L19.5 13.4481Z" stroke-width="0.3" /></svg>Via Email</Link>
                                </div>
                            </div>
                        </>
                    )}
                </section>
            </main>

            <Rodape />

        </section >
    );
}